'use strict';

// add listeners to add/remove selection boxes and close dropdowns for rooms filters
function getElements(attrib) {
	return document.querySelectorAll('[' + attrib + ']');
}

function updateClearAllButton($selecteditemscontainer) {
	// console.log ("fired update function");
	var checked = getElements('checked');
	var clearallbuttonmarkup = "<div class=\"filter-clear-all d-flex justify-content-center\"><span>Clear All</span></div>";
	if (checked.length) {
		if ($selecteditemscontainer.find('.filter-clear-all').length) {
			// console.log("found a clear all button");
			// do nothing
		} else {
			// console.log("trying to add a clear all button");
			$selecteditemscontainer.append(clearallbuttonmarkup);
			$selecteditemscontainer.parent().show();
		}
	} else {
		// console.log("got no filter selections");
		$selecteditemscontainer.find('.filter-clear-all').remove();
		$selecteditemscontainer.parent().hide();
	}
}

(function ($, Drupal) {
	if (Drupal) {
		Drupal.behaviors.initHotelRoomsExposedFilters = {
			attach: function attach(context, settings) {
				// enumerate the parts of the form
				var formContainer, formDropDowns, selectedItemsContainer, selectBoxes, form, matchingFormItem;

				formContainer = $('.view-room-listings-by-hotel');
				form = formContainer.find('form.views-exposed-form');
				selectedItemsContainer = formContainer.find('.view-filter-selections > .container');
				selectBoxes = form.find('.form-item input[type="checkbox"]');
				formDropDowns = form.find('details.form-item');

				updateClearAllButton(selectedItemsContainer);

				// attach listeners to create/remove selection boxes
				if (selectBoxes.length && formContainer.length) {
					selectBoxes.once().click(function () {
						var itemvalue, itemname;
						itemvalue = $(this).val();
						itemname = $(this).next('label').text();
						if ($(this).prop('checked')) {
							selectedItemsContainer.prepend("<div data-item-value=\"" + itemvalue + "\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + itemname + "</span></div>");
						} else {
							formContainer.find('.view-filter-selections > .container').find('div:contains(' + itemname + ')').remove();
						}
						updateClearAllButton(selectedItemsContainer);
					});

					// attach listeners refresh select boxes on AJAX load
					selectBoxes.each(function () {
						var itemvalue, itemname;
						itemvalue = $(this).val();
						itemname = $(this).next('label').text();
						if ($(this).prop('checked')) {
							selectedItemsContainer.find('.filter-selection[data-item-value="' + itemvalue + '"]:contains("' + itemname + '")').remove();
							selectedItemsContainer.prepend("<div data-item-value=\"" + itemvalue + "\" class=\"selected-item filter-selection d-flex justify-content-center\"><span>" + itemname + "</span></div>");
						}
					});
				}

				if (selectedItemsContainer.length && formContainer.length) {
					// attach listeners to uncheck corresponding inputs when their selected item is clicked to dismiss it
					selectedItemsContainer.on('click', 'div.selected-item', function () {
						var itemvalue, itemname;
						itemvalue = $(this).data('item-value');
						itemname = $(this).text();
						matchingFormItem = selectBoxes.filter("[value='" + itemvalue + "']");
						$(this).remove();
						// doublecheck that the text label and the ID match so we don't remove the wrong item
						if (matchingFormItem.next('label').text() === itemname) {
							matchingFormItem.prop("checked", false);
						}
						form.find('input.form-submit').once().click();
						updateClearAllButton(selectedItemsContainer);
					});

					// attach listener to clear all input selections and uncheck all boxes when the "Clear All" button is clicked
					selectedItemsContainer.on('click', 'div.filter-clear-all', function () {
						selectBoxes.prop('checked', false);
						selectedItemsContainer.find('.filter-selection').remove();
						form.find('input.form-submit').once().click();
						// updateClearAllButton(selectedItemsContainer);
					});
				}

				//attach listeners to the body to close any dropdowns when clicked
				$('body').click(function (e) {
					if ($(e.target) !== formDropDowns) {
						formDropDowns.removeAttr('open');
					}
				});

				formDropDowns.click(function (e) {
					e.stopPropagation();
				});
			}
		};
	}

	// auto submit offers exposed filter on change
	Drupal.behaviors.initOffersExposedFilters = {
		attach: function attach(context, settings) {
			var form;
			form = $('.view-offers-card-grid').find('.views-exposed-form');
			$('.form-select', form).on('change', function () {
				form.find('input.form-submit').once().click();
			});
		}
	};

	// auto submit testimonials on change
	Drupal.behaviors.initAccoladesExposedFilters = {
		attach: function attach(context, settings) {
			var form;
			form = $('.view-accolades').find('.views-exposed-form');
			$('.form-select', form).on('change', function () {
				form.find('input.form-submit').once().click();
			});
		}
	};

	// add social links to manage reservations page
	Drupal.behaviors.socialLinksHackyHack = {
		attach: function attach(context, settings) {
			$(document, context).once().each(function () {
				var pathName = window.location.pathname;
				if (pathName === "/manage-reservations") {
					var brandFooter = document.querySelector("#block-brandfooter");
					var socialLinks = '<div class="c-social-links">\n\t\t\t\t\t\t\t<div class="social-icons">\n\t\t\t\t\t\t\t\t<p>Follow Hacienda Cabo</p>\n\t\t\t\t\t\t\t\t<div class="social-icons-wrapper">\n\t\t\t\t\t\t\t\t\t<a title="" href="https://www.instagram.com/haciendacabo/" rel="noopener" target="_blank" class="instagram" aria-label="Follow Hacienda Cabo on instagram">\n\t\t\t\t\t\t\t\t\t\t<i class="instagram">\n\t\t\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm138 0q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zm108-410q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zm-502-220q-7 0-76.5-.5t-105.5 0-96.5 3-103 10-71.5 18.5q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5.5 76.5-.5 76.5 0 105.5 3 96.5 10 103 18.5 71.5q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-.5 76.5.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-.5-76.5.5-76.5 0-105.5-3-96.5-10-103-18.5-71.5q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5.5zm768 630q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"></path></svg>\n\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a title="" href="https://www.facebook.com/haciendacabo/?ref=br_rs" rel="noopener" target="_blank" class="facebook" aria-label="Follow Hacienda Cabo on facebook">\n\t\t\t\t\t\t\t\t\t\t<i class="facebook">\n\t\t\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path></svg>\n\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t<a title="" href="https://twitter.com/haciendacabo" rel="noopener" target="_blank" class="twitter" aria-label="Follow Hacienda Cabo on twitter">\n\t\t\t\t\t\t\t\t\t\t<i class="twitter">\n\t\t\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1684 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"></path></svg>\n\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>';
					brandFooter.insertAdjacentHTML('afterend', socialLinks);
				} else {
					return false;
				}
			});
		}
	};

	// Removes the field inheritance block for ADA
	document.addEventListener("DOMContentLoaded", function () {
		var fieldInheritance = $('#field-inheritance--wrapper');
		fieldInheritance.each(function () {
			$(this).remove();
		});
	});
})(jQuery, Drupal);